import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, from, mergeMap, of, switchMap } from 'rxjs';
import { TrackingFeature } from '..';
import { VehicleApiService } from '../../api/vehicle-api.service';
import { actions } from './battery-certificate.actions';

@Injectable()
export class BatteryCertificateEffects {
    protected readonly actions$ = inject(Actions);
    protected readonly store = inject(Store);
    protected readonly vehicleApi = inject(VehicleApiService);

    loadHyundaiPromiseVM$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadBatteryCertificate),
            switchMap(() =>
                from(this.vehicleApi.getOverlayBatteryCertificate()).pipe(
                    mergeMap((content) => [
                        TrackingFeature.actions.overlayTracking({ label: 'battery certificate' }),
                        actions.loadBatteryCertificateSuccess({ content }),
                    ]),
                    catchError((error) => of(actions.loadBatteryCertificateFailure({ error }))),
                ),
            ),
        );
    });
}
